export default "__VITE_ASSET__e002433c__"